import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app-routing';
import { AppComponent } from './app.component';
import { AppErrorHandler } from './error-handlers/app.error-handler';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      initialNavigation: 'enabledBlocking',
      anchorScrolling: "enabled",
      scrollPositionRestoration: 'top',
      scrollOffset: [0, 50]
    }),
    HttpClientJsonpModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    }],
  bootstrap: [AppComponent],
})
export class AppModule { }
